import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useAdmin } from "@/hooks/useAdmin";

const Index = () => {
  const { session, loading: authLoading } = useAuth();
  const { isAdmin, role, loading: adminLoading } = useAdmin();

  if (authLoading || (session && adminLoading)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  if (isAdmin) {
    return <Navigate to={role === "sales" ? "/admin/contracts" : "/admin"} replace />;
  }

  return <Navigate to="/dashboard" replace />;
};

export default Index;
